import mitt from 'mitt'

import type {CoreEvents} from "@/core/events/core.events";
import type {ColaboradorEvents} from "@/modules/colaborador";
import type {CteEvents} from "@/modules/cte";
import type {LancamentoEvents} from "@/modules/lancamento";
import type {LancamentoRecorrenciaEvents} from "@/modules/lancamentoRecorrencia";
import type {NfseEvents} from "@/modules/nfse";
import type {ExtratoEvents} from "@/modules/extrato";
import type {PedidoCompraEvents} from "@/modules/pedidoCompra";
import type {ListaArranqueEvents} from "@/modules/listaArranque";
import type {RequisicaoCompraEvents} from "@/modules/requisicaoCompra";
import type {TransferenciaEvents} from "@/modules/transferencia";

/*
 * Composition root dos eventos: a união dos mapas declarados pelo core e por cada módulo.
 * Não existe god-file de eventos — quem declara `lancamento:gravado` é o módulo lancamento.
 *
 * Substituiu o antigo `stores/events.store.ts`, que instanciava 10 classes de evento com
 * `reactive` e obrigava todo consumidor a montar um `watch` num objeto mutável.
 */
export type AppEvents =
    CoreEvents
    & ColaboradorEvents
    & CteEvents
    & NfseEvents
    & LancamentoEvents
    & LancamentoRecorrenciaEvents
    & ExtratoEvents
    & PedidoCompraEvents
    & ListaArranqueEvents
    & RequisicaoCompraEvents
    & TransferenciaEvents;

const eventBus = mitt<AppEvents>()

export default eventBus
